import axios from '../axios';
import config from '../../config';
const { clubhubUrl, eliteUrl } = config;
const clubhub = {
    // 精英人才库列表
    clubEliteList(data) {
        let xTenantId = data['x-tenant-id'];
        delete data['x-tenant-id'];
        return axios(clubhubUrl + '/player/all', {
            method: 'post',
            data,
            headers: {
                'x-tenant-id': xTenantId,
            },
        });
    },
    clubElite(params, xTenantId) {
        return axios(eliteUrl + '/teamup-elite/elite', {
            method: 'get',
            params,
            headers: {
                'x-tenant-id': xTenantId,
            },
        });
    },
    // 获取场景下的动态字段
    getFidldByScene(data, tenantId) {
        return axios(clubhubUrl + '/user/field_config/scene', {
            method: 'post',
            data,
            headers: {
                'x-tenant-id': tenantId,
            },
        });
    },
    // 获取人员动态字段数值
    getInfoFidld(data, tenantId) {
        return axios(clubhubUrl + '/user/fields', {
            method: 'post',
            data,
            headers: {
                'x-tenant-id': tenantId,
            },
            tenant: false,
        });
    },
    // 获取用户的信息
    getUserFieldInfo(data, tenantId) {
        return axios(clubhubUrl + '/user/info', {
            method: 'post',
            data,
            headers: {
                'x-tenant-id': tenantId,
            },
        });
    },
    // 用户梯队位置查询
    userPosition(data) {
        return axios(`${clubhubUrl}/user/position`, {
            method: 'post',
            data,
        });
    },
    // 查询多个用户动态数据的值
    getMoreUserField(data, tenantId) {
        return axios(clubhubUrl + '/users', {
            method: 'post',
            data,
            headers: {
                'x-tenant-id': tenantId,
            },
            tenant: false,
        });
    },
    // 管理端的人员管理 -
    // adminUserList(data) {
    //     return axios(clubhubUrl + '/user/list', {
    //         method: 'post',
    //         data,
    //     });
    // },
    // 管理端的人员管理
    adminUserList(params) {
        return axios('/user/list', {
            method: 'get',
            params,
            groupId: true,
        });
    },
    getClubPlayersList(data) {
        //获取球队内所有球员列表
        return axios(`${clubhubUrl}/team/players`, {
            method: 'post',
            data,
        });
    },
};
export default clubhub;
